import React from 'react';

/**
 * Without this, one thrown error anywhere blanks the whole site — which is
 * exactly what a visitor saw when a stale bundle met current data.
 *
 * `messages` is passed in rather than read from a hook, so this still works
 * if the failure is in the language context itself.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error, info) {
        // Keep it in the console for anyone looking; there is no reporting
        // service to send it to.
        console.error('Something broke while rendering:', error, info);
    }

    handleReload = () => {
        window.location.href = '/';
    };

    render() {
        if (!this.state.failed) return this.props.children;

        const { title, body, button } = this.props.messages;
        return (
            <div className="homepage-content" role="alert">
                <h1>{title}</h1>
                <p className="homepage-text">{body}</p>
                <div className="homepage-button-group">
                    <button
                        type="button"
                        className="homepage-action-button"
                        onClick={this.handleReload}
                    >
                        <span className="button-text">{button}</span>
                    </button>
                </div>
            </div>
        );
    }
}

ErrorBoundary.defaultProps = {
    messages: {
        title: 'Something went wrong',
        body: 'Sorry — this page could not be shown. Going back to the start usually fixes it.',
        button: 'Back to the start',
    },
};

export default ErrorBoundary;
